import { library } from '@fortawesome/fontawesome-svg-core';

import {
  faDoorOpen,
  faSignature,
  faSignatureSlash,
  faUsers as fadUsers,
} from '@fortawesome/pro-duotone-svg-icons';

import {
  faBoxArchive,
  faBuilding,
  faCalendarCircleExclamation,
  faCalendarXmark,
  faCircle,
  faCircleCheck,
  faClipboard,
  faCloudArrowUp,
  faFileArrowUp,
  faFileContract,
  faFileLines,
  faGear,
  faHouse,
  faLocationDot,
  faLocationPen,
  faLocationPlus,
  faPlus,
  faRepeat,
  faSignOut,
  faUserPen,
  faUserPlus,
  faUsers as falUsers,
  faXmark,
} from '@fortawesome/pro-light-svg-icons';

library.add(
  faHouse,
  falUsers,
  fadUsers,
  faGear,
  faLocationDot,
  faSignature,
  faSignatureSlash,
  faDoorOpen,
  faUserPlus,
  faLocationPen,
  faLocationPlus,
  faBoxArchive,
  faFileLines,
  faPlus,
  faUserPen,
  faFileArrowUp,
  faFileContract,
  faCircle,
  faCircleCheck,
  faBuilding,
  faXmark,
  faCalendarCircleExclamation,
  faCalendarXmark,
  faRepeat,
  faCloudArrowUp,
  faSignOut,
  faClipboard
);
